import Link from 'next/link';
import React from 'react';

const News_item = ({
	data,
	classes = 'grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2 md:grid-cols-3',
}) => {
	function getDate(timestamp) {
		const date = new Date(timestamp*1000);
		const options = { day: "numeric", month: "short", year: "numeric" };
		return date.toLocaleDateString("en-US", options);
	  }
	
	  function getShortDesc(richText) {
		if(richText){
			const parser = new DOMParser();
			const html = parser.parseFromString(richText, "text/html");
			const plainText = html.body.textContent.trim();
			return `${plainText.substring(0, 120)}...`;
		}else{
			return '';
		}
	  }
	  if(!data){
		return<></>
	  }

	return (
		<>
			<div className={classes} style={{ gridAutoRows: '1fr' }}>
				{data.map((item) => {
					
					const {
						title,
						image,
						author,
						content,
						readtime,
						date,
						category,
						id
					  } = item;
					return (
						<article key={id}>
							<div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg h-full">
								<figure className="group overflow-hidden ">
									<Link href={`/single_post/${id}`}>
											<img
												src={image}
												alt={title}
												className="h-[186px] w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 "
											/>
									</Link>
								</figure>

								{/* <!-- Body --> */}
								<div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border border-t-0 bg-white p-[10%] h-full">
									{/* <!-- Meta --> */}
									<div className="mb-3 flex flex-wrap items-center space-x-1 text-xs">
										<div
											href="#"
											className="dark:text-jacarta-200 text-jacarta-700 hover:text-accent"
										>{author}</div>
										<span className="dark:text-jacarta-400">in</span>
										<span className="text-accent inline-flex flex-wrap items-center space-x-1">
											<div href="#">{category}</div>
										</span>
									</div>

									<h2 className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white">
										<Link href={`/single_post/${id}`}>
											<div> {title} </div>
										</Link>
									</h2>
									<p className="dark:text-jacarta-200 mb-8">{getShortDesc(content)}</p>

									{/* <!-- Date / Time --> */}
									<div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
										<span>
											<time>{getDate(date/1000)}</time>
										</span>
										<span>•</span>
										<span>{readtime}</span>
									</div>
								</div>
							</div>
						</article>
					);
				})}
			</div>
		</>
	);
};

export default News_item;
